import React, { useEffect, useState } from 'react';
import {
	getActebi,
	getActebiCategory,
	getSubCategory,
	getSubCategorySlug,
	getYears,
} from '../../service/service';
import pdf from '../../images/collection-pdf.png';
import { useParams } from 'react-router-dom';

export default function ActebiFilters() {
	const { slug } = useParams();
	const [years, setYears] = useState([]);
	const [selectedYear, setSelectedYear] = useState(null);
	const [category, setCategory] = useState([]);
	const [finalyCategory, setFinalyCategory] = useState([]);
	const [angarishebi, setAngarishebi] = useState([]);

	useEffect(() => {
		if (years.length > 0 && selectedYear === null) {
			setSelectedYear(years[0].year);
		}
	}, [years, selectedYear]);

	useEffect(() => {
		const getYearsFc = async () => {
			const data = await getYears();
			setYears(data);
		};
		getYearsFc();
	}, []);

	useEffect(() => {
		const getCategory = async () => {
			const data = await getSubCategory();
			setCategory(data);
		};
		getCategory();
	}, []);

	useEffect(() => {
		const filterActs = category.filter(item => item.slug === slug);
		setFinalyCategory(filterActs);
	}, [category, slug]);

	useEffect(() => {
		const getActs = async () => {
			if (finalyCategory.length > 0 && years.length > 0) {
				const yearToUse = selectedYear || years[0]?.year;
				const data = await getSubCategorySlug(
					finalyCategory[0]?.title,
					yearToUse
				);
				setAngarishebi(data);
			}
		};
		getActs();
	}, [finalyCategory, years, selectedYear]);

	const handleYearClick = async (title, year) => {
		const angarishebi = await getSubCategorySlug(title, year);
		setAngarishebi(angarishebi);
		setSelectedYear(year);
	};

	return (
		<>
			<ul className='years--filter__container'>
				{years?.map(year => (
					<li
						key={year.id}
						onClick={() => handleYearClick(finalyCategory[0]?.title, year.year)}
						className={
							year.year === (selectedYear || years[0]?.year) ? 'active' : ''
						}
					>
						{year.year}
					</li>
				))}
			</ul>
			{angarishebi.length > 0 ? (
				angarishebi?.map(item => (
					<div key={item.id} className='angarishebi-item'>
						<a href={item.file} target='_blank' rel='noopener noreferrer'>
							<span>{item.title}</span>
							<img src={pdf} alt='' />
						</a>
					</div>
				))
			) : (
				<h4>....</h4>
			)}
		</>
	);
}
